'use strict';

export default {
  organizationMenu: {
    addOrganization: 'Create your organization',
    changeOrganizationSuccess: 'Organization successfully changed !',
    changeOrganizationError: 'Error while changing organization !',
    noOrganizations: '*No organizations to show',
    modal: {
      name: 'Organization name',
      avatar: 'Logo',
      addOrganization: 'Create',
      cancelButton: 'Cancel',
      addOrganizationSuccess: 'Organization successfully added !',
      addOrganizationError: 'Error while adding organization',
      chooseAvatar: 'Choose file',
      upload: 'Upload',
      organizationChange: 'Switched to ',
      organizationChangeBaseText: 'another organization successfully',
      errorName: 'Valid name required',
      errorNoName: "Name can't be empty",
      import: 'Import an image',
      currency: 'Currency',
    },
  },
};
